import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const links = [
  { to: '/support', label: 'Support' },
  { to: '/contact', label: 'Contact' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

export const AuthenticatedFooter = () => {
  return (
    <footer className="bg-midnight-green mt-auto border-t border-copper/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs">
          <Link
            to="/"
            className="story-link inline-flex items-center gap-2 font-inter text-sand/75 hover:text-copper transition-colors"
          >
            <Home className="h-3.5 w-3.5" />
            Main site
          </Link>

          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-inter text-sand/55">
            {links.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className="story-link hover:text-copper transition-colors"
              >
                {l.label}
              </Link>
            ))}
            <span className="text-sand/30">©&nbsp;{new Date().getFullYear()} CampChef Pro</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
